module.exports = "Create a new directory `stuff` inside of a new directory `some`, which should live\ninside the root directory ( `/` ).\n"